import {
    AfterViewInit,
    Component, HostListener, OnInit,
    ViewChild
} from '@angular/core';
import { Store } from '@ngrx/store';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TabsetComponent } from 'ngx-bootstrap/tabs';

@Component({
    selector: 'appointment-log',
    templateUrl: './appointment-log.component.html'
})
export class AppointmentLogComponent implements OnInit {

    @ViewChild('staticTabs', { static: false }) staticTabs: TabsetComponent;
    appointmentLog: any = {};
    selectedEventLog: any;
    selectedXmlIdList: Array<any>;
    selectedAppointmentDetail: any;
    logEventLoading: boolean;
    appointmentTimeMs = 1621252800000;
    selectedTimeZone = undefined;
    isUTC = false;
    isAR3User = false;

    constructor(public store: Store<any>,
                public bsModalRef: BsModalRef,
                private modalService: BsModalService) {
    }

    public onCancel(): void {
        this.bsModalRef.hide();
    }

    setEventLog(selectEventLog): void {
        this.selectedEventLog = selectEventLog;
    }

    setXmlIdList(selectXmlIdList): void {
        this.selectedXmlIdList = selectXmlIdList;
    }

    selectAppointmentDetail(selectAppointmentDetail): void {
        this.selectedAppointmentDetail = selectAppointmentDetail;
    }

    setLogEventLoading(logEventLoading): void {
        this.logEventLoading = logEventLoading;
    }

    @HostListener('document:keypress', ['$event'])
    keyEvent(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.onCancel();
        }
    }

    ngOnInit(): void {
        const config: any = {...this.modalService.config.initialState};
        this.appointmentLog = config;
        this.appointmentTimeMs = Number(this.appointmentLog.appointment.appointmentTimeMs);
        this.selectedTimeZone = this.appointmentLog.userTimeZone;
        this.isAR3User = this.appointmentLog.userPermissionKeys
            .findIndex(userPermissionKey => userPermissionKey === 'autoremind3:reminders') !== -1;
    }

    toggleTimeZone(): void {
        this.isUTC = !this.isUTC;
        this.selectedTimeZone = this.selectedTimeZone === 'UTC' ? this.appointmentLog.userTimeZone : 'UTC';
    }
}
